'use strict';var _globals=require('./lib/utils/globals');_globals.global.probe={};
//# sourceMappingURL=init.js.map


//////////////////
// WEBPACK FOOTER
// ./~/probe.gl/dist/init.js
// module id = 1565
// module chunks = 0